<template>
  <v-container>
    <v-layout row wrap v-if="!loaded">
      <v-flex offset-xs5 offset-sm6 pt-5>
        <v-progress-circular :size="70" :width="7" color="light-blue darken-4" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-card v-if="loaded">
      <v-card-title class="headline">
        Tipi Corsi
        <v-spacer>
          <v-layout row>
            <v-flex xs12 v-if="isUserAdmin">
              <TypeCourseDialog />
            </v-flex>
          </v-layout>
        </v-spacer>
      </v-card-title>
      <v-layout row wrap mb-3>
        <v-spacer></v-spacer>
        <v-flex xs12 md8 lg5 mx-3>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Cerca"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="courseTypes"
        :search="search"
        :loading="loading"
        :rows-per-page-items="[10,25,40]"
        rows-per-page-text="Righe per pagina"
      >
        <template v-slot:items="props">
          <tr @click="props.expanded = !props.expanded">
            
            <td>{{ props.item.nome }}</td>
            <td>
              <v-icon color="black" flat @click="selectCourseType(props.item.id)">visibility</v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert
            :value="true"
            color="error"
            icon="warning"
          >La tua ricerca per "{{ search }}" non ha dato risultati.</v-alert>
        </template>
        <template v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">Nessun valore da visualizzare</v-alert>
        </template>
        <template
          v-slot:pageText="props"
        >{{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
        <template v-slot:expand="props">
          <v-card flat color="blue-grey lighten-4">
            <v-card-text>{{props.item.descrizione}}</v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import TypeCourseDialog from "../components/NewCourseTypeDialog";
import { db } from "../main";
import { bus } from "../main";
export default {
  components: { TypeCourseDialog },
  data: () => ({
    search: "",
    headers: [
      {
        text: "Visualizza",
        align: "left",
        sortable: false,
        value: ""
      },
      {
        text: "Nome",
        align: "left",
        value: "nome"
      }
    ],
    courseTypes: [],
    loaded: false,
    loading: false
  }),

  methods: {
    //metodo per la selezione dei Tipi Corso
    selectCourseType(courseTypeID) {
      this.$store.dispatch("setCourseType", courseTypeID);
      this.$router.push("/courseTypes/" + courseTypeID);
    }
  },
  computed: {
    //controlla se l'utente è admin
    isUserAdmin() {
      return this.$store.getters.getRole === "Admin";
    }
  },
  //metodo per il riempimento della tabella dei Tipi Corso
  created() {
    db.collection("tipi_corso").onSnapshot(
      querySnapshot => {
        this.courseTypes = [];
        querySnapshot.forEach(doc => {
          const type = {
            nome: doc.data().nome,
            descrizione: doc.data().descrizione,
            id: doc.id
          };
          this.courseTypes.push(type);
        });
        this.loaded = true;
      },
      function(error) {
        bus.$emit(
          "errorOperation",
          "Errore: problema nel caricamento dei tipi corso(" + error + ")"
        );
      }
    );
  }
};
</script>

